import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { map } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class MessagesService {

  constructor(private http: HttpClient) { }

  //observables 
  public _areMultipleRecepientsSelected = new BehaviorSubject<boolean>(false);
  areMultipleRecepientsSelected = this._areMultipleRecepientsSelected.asObservable();

  private _currentSelectedMsg = new BehaviorSubject<any>({});
  currentSelectedMsg = this._currentSelectedMsg.asObservable();

  setCurrentSelectedMsg(msg: any) {
    this._currentSelectedMsg.next(msg);
  }

  getCurrentSelectedMsg() {
    return this._currentSelectedMsg;
  }


  private _preSelectedUserIds = new BehaviorSubject<any>([]);
  preSelectedUserIds = this._preSelectedUserIds.asObservable();

  setPreSelectedUserIds(ids: any) {
    this._preSelectedUserIds.next(ids);
  }

  getPreSelectedUserIds() {
    return this._preSelectedUserIds;
  }

  private _singleRecipientName = new BehaviorSubject<string>('');
  singleRecipientName = this._singleRecipientName.asObservable();

  setSingleRecipientName(name: string) {
    this._singleRecipientName.next(name);
  }

  getSingleRecipientName() {
    return this._singleRecipientName;
  }

  private _tableViewReload = new BehaviorSubject<object>({});
  tableViewReload = this._tableViewReload.asObservable();

  setTableViewReload(bool) {
    this._tableViewReload.next(bool);
  }

  getTableViewReload() {
    return this._tableViewReload;
  }


  //http
  getMessages(perPage: number, page: number, sortType: string , searchText) {
    if (searchText) {
      return this.http.get(environment.url + `admin/schools/${localStorage.getItem('schoolId')}/messages?&per_page=${perPage}&page=${page}&sort[created_at]=${sortType}&search=${searchText}`);
    }
    return this.http.get(environment.url + `admin/schools/${localStorage.getItem('schoolId')}/messages?&per_page=${perPage}&page=${page}&sort[created_at]=${sortType}`);
  }

  sendMessageToUsers(body) {
    return this.http.post(environment.url + `admin/schools/${localStorage.getItem('schoolId')}/messages`, body)
  }

  getMessageRecipients(messageId: number, page: number, is_read: number) {
    if(is_read == 0){
      return this.http.get(environment.url + `admin/schools/${localStorage.getItem('schoolId')}/messages/${messageId}/recipients?page=${page}`);
    }
    return this.http.get(environment.url + `admin/schools/${localStorage.getItem('schoolId')}/messages/${messageId}/recipients?page=${page}&is_read=${is_read}`);
  }

  getFilteredUsers(body){
    return this.http.post(environment.url + `admin/schools/${localStorage.getItem('schoolId')}/users/filter`, body)
  }
}
